document.addEventListener("DOMContentLoaded", function () {
	const changesElements = document.querySelectorAll(".js-changes");

	changesElements.forEach((el) => {
		const spans = el.querySelectorAll(".befaf span");
		const lastSpan = spans[spans.length - 1];

		spans.forEach((span) => {
			span.addEventListener("click", function () {
				spans.forEach((s) => s.classList.remove("is-active"));
				this.classList.add("is-active");

				if (this === lastSpan) {
					el.classList.add("is-active");
				} else {
					el.classList.remove("is-active");
				}
			});
		});
	});
});
